// PhotoGallery
export const SHOW_PHOTO_GALLERY = 'showPhotoGallery';
export const CLEAN_PHOTO_GALLERY = 'closePhotoGallery';
export const SET_PHOTO_GALLERY = 'setPhotoGallery';
export const SET_PHOTO_INDEX = 'setPhotoIndex';
